var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99584 1.11027e-05C7.13905 0.00012267 7.27648 0.0528203 7.37782 0.146402L13.828 6.13572C13.9353 6.22808 13.9974 6.35665 13.9999 6.49212C14.0025 6.62748 13.9454 6.75805 13.8417 6.85376C13.738 6.94957 13.5966 7.00226 13.45 6.99993C13.3033 6.99747 13.164 6.94021 13.064 6.84117L6.95977 1.21121L0.819403 6.8811C0.677998 6.95975 0.505219 6.97446 0.35066 6.92087C0.195983 6.86728 0.076416 6.75131 0.0258512 6.60615C-0.024582 6.46098 -0.000451149 6.30234 0.0914859 6.17566L6.61393 0.152965L6.61393 0.153076C6.71395 0.0569302 6.85149 0.00189462 6.99591 6.12317e-07L6.99584 1.11027e-05Z",
    fill: "#363636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/icon-arrow-up.e433a0b5befdadb4dcb5452d04d457bc.svg";
export { ForwardRef as ReactComponent };